import React from 'react';
import * as S from './NotificationPanel.styles';

export interface NotificationProps {
  text: string;
}

const Notification: React.FC<NotificationProps> = ({ text }) => {
  return (
    <S.NotificationWrapper>
      <S.NotificationText dangerouslySetInnerHTML={{ __html: text }} />
    </S.NotificationWrapper>
  );
};

export default Notification;
